import React from "react";
import { Button } from "antd";
import Modal from "@app/components/modal";
import applicationStore from "@app/state/store/application";
import session from "@app/state/store/session";
import { localStore } from "@app/lib/storage";

const SessionExpiredModal = ({ visible }) => {
    const [, setLastReloginTime] = React.useState(null);

    const refreshPage = () => {
        window.location.reload(false);
    };

    const isSSOEnabled = applicationStore.settings?.sso?.enabled;
    const ssoProvider = applicationStore.settings?.sso?.provider;
    const hasRememberMeToken = !!localStore.get("auth.token");

    const ProviderButtonLabel = {
        okta: "Sign In using Okta",
        azure: "Sign In using Microsoft Azure",
    };

    const handleAutoLogin = async () => {
        setLastReloginTime(new Date());

        try {
            await session.autoLogin();
            if (!session.loggedIn) {
                refreshPage();
            }
        } catch (_e) {
            refreshPage();
        }
    };

    const handleSSOLogin = () => {
        setLastReloginTime(new Date());

        if (ssoProvider === "okta") {
            session.loginOkta({ relogin: true });
        } else if (ssoProvider === "azure") {
            session.loginAzure({ relogin: true });
        }
    };

    return (
        <Modal
            visible={visible}
            footer={null}
            closable={false}
            centered
            style={{ textAlign: "center" }}
        >
            <div style={{ marginBottom: "1rem" }}>
                Your session has expired.
                <br />
                Click here to sign in
            </div>
            {isSSOEnabled ? (
                <Button
                    type="primary"
                    size="large"
                    onClick={handleSSOLogin}
                    style={{ width: "100%" }}
                >
                    {ProviderButtonLabel[ssoProvider]}
                </Button>
            ) : (
                <Button onClick={hasRememberMeToken ? handleAutoLogin : refreshPage} type="primary">
                    Log In
                </Button>
            )}
        </Modal>
    );
};

export default SessionExpiredModal;
